// Registration status constants for multi-tenant user flow
export const REGISTRATION_STATUS = {
  NONE: 'none',
  PENDING_CONFIRMATION: 'pending-confirmation',
  EXISTING_USER: 'existing-user',
}
